"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectUnseenMessages = exports.selectIsMaximised = exports.selectMessages = undefined;

var _reselect = require("reselect");

var selectChat = function selectChat(state) {
  return state.chat;
};

var selectMessages = exports.selectMessages = (0, _reselect.createSelector)(selectChat, function (chat) {
  return chat.messages;
});
var selectIsMaximised = exports.selectIsMaximised = (0, _reselect.createSelector)(selectChat, function (chat) {
  return chat.isMaximised;
});
var selectUnseenMessages = exports.selectUnseenMessages = (0, _reselect.createSelector)(selectChat, function (chat) {
  return chat.unseenMessages;
});